import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiService, AuthService, LanguageService} from "../../../services";
import {UntypedFormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DoctorService} from "../../../services/doctor.service";
import {DoctorSearchResultModel} from "../../../models/doctor-search-result.model";
import {Subject} from "rxjs";
import {CONFIG} from "../../../core/config/config";
import {Moment} from "moment";
import {translateToEnglish} from "../../helpers/string.utils";

@Component({
  selector: 'app-doctor-search-result',
  templateUrl: './doctor-search-result.component.html',
  styleUrls: ['./doctor-search-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoctorSearchResultComponent implements OnInit {
  @Input() doctor: DoctorSearchResultModel;
  @Input() renderDates: Moment[];
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public apiUrl = CONFIG.API.REST.API_URLS['ApiUrl'];
  public toggleSlots: boolean = false;
  specialityFormControl = new UntypedFormControl();
  @Input() selectedServiceType: number;
  @Input() selectedSpeciality: number;
  @Output() selectedTimeSlot = new EventEmitter();
  @Output() onSpecialtyChange = new EventEmitter();
  @Output() navigateToClosestAvailableDate = new EventEmitter<{ specialtyId: number, date: number, keyword?: number }>();
  @Output() reinitializeSearchResults = new EventEmitter();

  doctorSelectedSpecialty: any;
  doctorClicked: Subject<void> = new Subject<void>();
  updatedPrice

  constructor(public LS: LanguageService,
              public API: ApiService,
              private doctorService: DoctorService,
              public Auth: AuthService,
              public route: ActivatedRoute,
              public router: Router) {
    this.cLang = this.LS.getLang();
  }

  ngOnInit() {
    if (this.selectedSpeciality) {
      this.specialityFormControl.setValue(this.selectedSpeciality);
    } else {
      this.specialityFormControl.setValue(this.doctor.specialties.length > 0 ? this.doctor.specialties[0].specialtyId : this.doctor.specialtiesAll[0].specialtyId);
    }
  }

  onDoctorClick() {
    this.doctorClicked.next();
  }

  goToDoctorPublicProfile(event: any) {
    
    this.router.navigate([`/eqimi/${translateToEnglish(this.doctor.fullName.replace(' ', '-'))}/${this.doctor.userId}/${this.doctor.clinic && this.doctor.clinic.id ? this.doctor.clinic.id : ''}`],
    {queryParams : {insurance: this.route.snapshot.queryParamMap.has("insurance"), selectedSpeciality: event.selectedSpecialty, selectedServiceType: this.selectedServiceType}}
    )
      .then(
        () => {
          this.doctorService.setSelectedDoctorData({
            data: this.doctor,
            renderDates: this.renderDates,
            selectedServiceType: this.selectedServiceType,
            selectedSpeciality: event.selectedSpecialty
          });
        }
      );
  }

  specialtyChanged($event: any) {
    if (this.doctor.clinic) {
      $event['clinic'] = this.doctor.clinic.id;
    }
    this.onSpecialtyChange.emit($event);
    this.doctorSelectedSpecialty = $event.specialtyId;
  }

  serviceTypeChanged($event: any) {
    this.selectedServiceType = $event;
  }

  updateUrl($event) {
    $event.target.src = 'assets/photos/avatar-3.png';
  }

  reinitializeSearch(data) {
    this.reinitializeSearchResults.emit(data);
  }

  goToDoctorProfile(event: any) {
    const queryParams = {
      selectedSpeciality: event.selectedSpecialty,
      selectedServiceType: this.selectedServiceType,
    };
  
    if (this.route.snapshot.queryParamMap.has("insurance")) {
      queryParams['insurance'] = true;
    }
  
    this.router.navigate([`/eqimi/${translateToEnglish(this.doctor.fullName.replace(' ', '-'))}/${this.doctor.userId}/${this.doctor.clinic && this.doctor.clinic.id ? this.doctor.clinic.id : ''}`],
      { queryParams }
    )
      .then(() => {
        this.doctorService.setSelectedDoctorData({
          data: this.doctor,
          renderDates: this.renderDates,
          ...queryParams,
        });
      });
  }

  doctorUpdated(event) {
    this.doctor = event
  }
}
